export default "__VITE_ASSET__bb9970e0__"